import React, { useEffect, useState } from "react";
import { RoleListWrapper } from "../Partners/style/role";
import API from "../../api/axios";
import { APP_URLS } from "../../api/url";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import Pagination from "../../assets/SharedComponents/Pagination";
import RecordCount from "../../assets/SharedComponents/RecordCount/RecordCount";
import { Tooltip } from "@mui/material";
import { FaFilterIcon } from "../../assets/Images/icon";
import { APIError } from "../../core/utils";
import SearchKey from "../../assets/SharedComponents/Search/SearchKey";
import StaticFilter from "../../assets/SharedComponents/Filters/StaticFilter";

import AddPartnerModal from "./components/AddPartnerModal";
import PartnersTable from "./components/PartnersTable";

const STATUS_OPTIONS = [
  { name: "Active", value: "1" },
  { name: "Inactive", value: "0" },
];

const OurPartners = () => {
  const [data, _data] = useState([]);
  const [dataDeleted, _dataDeleted] = useState(false);
  const [countValue, _countValue] = useState('');
  const [searchKeyword, _searchKeyword] = useState('');
  const [statusFilter, _statusFilter] = useState('');
  const [filters, _filters] = useState(false);
  const [loading, _loading] = useState(false);
  const [page, setPage] = useState(1);
  const [total, _total] = useState(0);
  const [totalPage, _totalPage] = useState(0);
  const [addPartner, _addPartner] = useState(false);
  const [editable, _editable] = useState('');
  const [loaded, _loaded] = useState(false);
  const [partnerName, _partnerName] = useState('');
  const [addPartnerStatus, _addPartnerStatus] = useState(1);
  const [togglingId, _togglingId] = useState(null);

  const permissions = JSON.parse(localStorage.getItem('permissions')) || [];
  const companyAccess = permissions.find((o) => o.slug === "manage_subsidiary");

  useEffect(() => {
    getOurPartners();
    _dataDeleted(false);
  }, [dataDeleted, page, countValue, searchKeyword, statusFilter]);

  const getOurPartners = () => {
    _loaded(true);
    const nameParam = searchKeyword ? `&filter[name]=${encodeURIComponent(searchKeyword)}` : '';
    const statusParam = statusFilter !== '' ? `&filter[status]=${statusFilter}` : '';
    API.get(APP_URLS.LIST_OUR_PARTNERS + `?page=${page}&per_page=${countValue}${nameParam}${statusParam}`)
      .then((res) => {
        const resp = res.data;
        if (resp.success === true) {
          _total(resp.data.total);
          _data(resp.data.data);
          _totalPage(resp.data.last_page);
          _loaded(false);
        } else {
          toast.error(resp.message, { position: toast.POSITION.TOP_RIGHT });
          _loaded(false);
        }
      })
      .catch(function (error) {
        _loaded(false);
        toast.error(APIError(error), { position: toast.POSITION.TOP_RIGHT });
      });
  };

  const editRecord = () => {
    const payload = { name: partnerName };
    if (!partnerName) {
      toast.error("Partner Name can't be blank", { position: toast.POSITION.TOP_RIGHT });
      return;
    }
    if (loading) return;
    _loading(true);
    API.post(APP_URLS.UPDATE_OUR_PARTNERS + `/${editable}?_method=patch`, payload)
      .then((res) => {
        _loading(false);
        const resp = res.data;
        if (resp.success === true) {
          toast.success("Our Partner Updated Successfully.", { position: toast.POSITION.TOP_RIGHT });
          getOurPartners();
          _partnerName('');
          _editable('');
        } else {
          toast.error(resp.message, { position: toast.POSITION.TOP_RIGHT });
        }
      })
      .catch(function (error) {
        _loading(false);
        toast.error(APIError(error), { position: toast.POSITION.TOP_RIGHT });
      });
  };

  const saveRecord = () => {
    const payload = { name: partnerName, status: addPartnerStatus };
    if (!partnerName) {
      toast.error("Partner Name can't be blank", { position: toast.POSITION.TOP_RIGHT });
      return;
    }
    if (loading) return;
    _loading(true);
    API.post(APP_URLS.ADD_OUR_PARTNERS, payload)
      .then((res) => {
        _loading(false);
        const resp = res.data;
        if (resp.success === true) {
          toast.success("Our Partner Added Successfully.", { position: toast.POSITION.TOP_RIGHT });
          _addPartner(false);
          _partnerName('');
          _addPartnerStatus(1);
          getOurPartners();
        } else {
          toast.error(resp.message, { position: toast.POSITION.TOP_RIGHT });
        }
      })
      .catch(function (error) {
        _loading(false);
        toast.error(APIError(error), { position: toast.POSITION.TOP_RIGHT });
      });
  };

  const removeType = (id) => {
    confirmAlert({
      title: "Confirm to remove",
      message: "Are you sure you want to remove?",
      closeOnEscape: true,
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            API.delete(APP_URLS.DELETE_OUR_PARTNERS + `/${id}`)
              .then((res) => {
                const resp = res.data;
                if (resp.success === true) {
                  _dataDeleted(true);
                  toast.success("Our Partner has been deleted successfully.", { position: toast.POSITION.TOP_RIGHT });
                } else {
                  toast.error(resp.message, { position: toast.POSITION.TOP_RIGHT });
                }
              })
              .catch(function (error) {
                toast.error(APIError(error), { position: toast.POSITION.TOP_RIGHT });
              });
          },
        },
        { label: "No" },
      ],
      closeOnClickOutside: true,
      overlayClassName: "overlay-custom-class-name",
    });
  };

  const handleSearchChange = (searchValue) => {
    _countValue(searchValue);
    if (searchValue !== "") {
      _totalPage(0);
      setPage(1);
    }
  };

  const handleNameSearch = (search) => {
    _searchKeyword(search);
    _totalPage(0);
    setPage(1);
  };

  const handleStatusFilterChange = (e) => {
    _statusFilter(e.target.value);
    _totalPage(0);
    setPage(1);
  };

  const clearFilter = () => {
    _filters(true);
    _searchKeyword('');
    _statusFilter('');
    handleSearchChange('');
    if (countValue !== '' || searchKeyword !== '' || statusFilter !== '') {
      _totalPage(0);
      setPage(1);
    }
  };

  const handleStatusToggle = (id, checked) => {
    if (togglingId !== null) return;
    const status = checked ? 1 : 0;
    const previousData = data;
    _togglingId(id);
    _data((prev) =>
      prev.map((p) => (p.id === id ? { ...p, status, is_active: status } : p))
    );
    API.post(APP_URLS.UPDATE_OUR_PARTNERS + `/${id}?_method=patch`, { status })
      .then((res) => {
        _togglingId(null);
        const resp = res.data;
        if (resp.success === true) {
          toast.success(
            status === 1 ? "Partner enabled successfully." : "Partner disabled successfully.",
            { position: toast.POSITION.TOP_RIGHT }
          );
        } else {
          _data(previousData);
          toast.error(resp.message, { position: toast.POSITION.TOP_RIGHT });
        }
      })
      .catch(function (error) {
        _togglingId(null);
        _data(previousData);
        toast.error(APIError(error), { position: toast.POSITION.TOP_RIGHT });
      });
  };

  const openAddModal = () => {
    _addPartner(true);
    _editable('');
    _addPartnerStatus(1);
    _partnerName('');
  };

  const closeAddModal = () => {
    _addPartner(false);
    _partnerName('');
    _addPartnerStatus(1);
  };

  if (!companyAccess) {
    return null;
  }

  const showActionColumn = companyAccess?.permissions?.find((o) => o.slug === "update") ||
    companyAccess?.permissions?.find((o) => o.slug === "delete");

  return (
    <RoleListWrapper>
      <div className="auctionMainContainer">
        <div className="row mt-4">
          <div className="col-md-4 offset-md-4">
            <h1 className="text-center">OUR PARTNERS</h1>
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-between info-wrap">
          <div className="justify-content-end mb-2 me-2">
            {companyAccess?.permissions?.find((o) => o.slug === "add") ? (
              <button onClick={openAddModal} className="btn">
                + Add
              </button>
            ) : (
              ""
            )}
          </div>
          <div className="justify-content-end mb-2 d-flex gap-2 mb-2 select-info align-items-center">
            <SearchKey
              onSearchClick={handleNameSearch}
              id="searchData"
              placeholder="Search by Name"
              val={searchKeyword}
              filters={filters}
              _filters={_filters}
            />
            <StaticFilter
              placeholder="All Status"
              data={STATUS_OPTIONS}
              value={statusFilter}
              handleChange={handleStatusFilterChange}
            />
            <RecordCount
              onSearchClick={handleSearchChange}
              id="pageCount"
              filters={filters}
              _filters={_filters}
            />
            <Tooltip title="Clear Filter" placement="bottom">
              <FaFilterIcon className="filter-icon" role="button" onClick={clearFilter} />
            </Tooltip>
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-between info-wrap">
          <div className="justify-content-end mt-1 me-2">
            <span className="text-start">Total Records : <b>{total}</b></span>
          </div>
        </div>

        <AddPartnerModal
          isOpen={addPartner}
          onClose={closeAddModal}
          partnerName={partnerName}
          onPartnerNameChange={(val) => _partnerName(val)}
          addPartnerStatus={addPartnerStatus}
          onAddPartnerStatusChange={_addPartnerStatus}
          loading={loading}
          onSave={saveRecord}
        />

        <div className="tableContainer">
          <table className="auctionTable">
            <thead className="tableHead">
              <tr className="table-row">
                <th className="tableHead-1">ID</th>
                <th className="tableHead-3">Name</th>
                <th className="tableHead-4">Status</th>
                <th className="tableHead-4">Created at</th>
                <th className="tableHead-5">Updated at</th>
                {showActionColumn ? <th className="tableHead-9">Action</th> : ""}
              </tr>
            </thead>
            <PartnersTable
              data={data}
              loaded={loaded}
              editable={editable}
              partnerName={partnerName}
              onPartnerNameChange={(val) => _partnerName(val)}
              companyAccess={companyAccess}
              togglingId={togglingId}
              onEditRecord={editRecord}
              onEditableChange={_editable}
              onPartnerNameSet={_partnerName}
              onStatusToggle={handleStatusToggle}
              onRemove={removeType}
            />
          </table>
        </div>

        <div>
          {totalPage > 1 ? (
            <Pagination
              totalPages={totalPage}
              page={page}
              key={totalPage}
              onPageClick={(p) => setPage(p + 1)}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </RoleListWrapper>
  );
};

export default OurPartners;
